import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HelpIcon from 'src/assets/images/icon_help.svg';
import { getBalanceAsOfDate } from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import { openModal } from 'src/redux/modules/modals/actions';
import { BALANCES_AS_OF_MODAL } from 'src/redux/modules/modals/modals.module';
import './BalancesAsOfToolTip.scss';

export enum TooltipLabel {
  ARIA_LABEL = 'View important information regarding the updating of account balances',
  LINK_TEXT = 'Important information regarding the updating of account balances',
}

const BalancesAsOfToolTip: React.VFC = () => {
  const dispatch = useDispatch();
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);

  return (
    <a
      aria-label={TooltipLabel.ARIA_LABEL}
      className="balance-tooltip"
      onClick={() => dispatch(openModal(BALANCES_AS_OF_MODAL))}
    >
      * Balances as of {balanceAsOfDate}
      <img
        alt={TooltipLabel.LINK_TEXT}
        className="balance-tooltip-icon"
        id="balance-tooltip-icon"
        src={HelpIcon}
      />
    </a>
  );
};

export default BalancesAsOfToolTip;
